import { motion } from "motion/react";
import { Link } from "react-router-dom";
import { solutionsGrid } from "@/mocks/home";

const solutionIcons = [
  "ri-lightbulb-line",
  "ri-hand-coin-line",
  "ri-tv-line",
  "ri-dashboard-line",
  "ri-calendar-event-line",
  "ri-video-line",
  "ri-home-smile-line",
  "ri-command-line",
  "ri-server-line",
  "ri-store-3-line",
  "ri-scan-line",
  "ri-customer-service-2-line",
];

export default function SolutionsGrid() {
  return (
    <section className="py-12 md:py-20 bg-white">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-10 md:mb-14"
        >
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-3">
            Solutions We Provide
          </h2>
          <div className="w-16 h-1 bg-accent mx-auto rounded-full"></div>
          <p className="text-sm md:text-base text-gray-500 mt-4 max-w-xl mx-auto">
            Comprehensive AV and smart technology solutions tailored to your organization's needs.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 max-w-6xl mx-auto">
          {solutionsGrid.map((solution, index) => (
            <Link
              key={solution.id}
              to={`/solutions/${solution.slug}`}
              className="group block"
            >
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.15 }}
                transition={{ duration: 0.5, delay: index * 0.08 }}
                whileHover={{ y: -6, transition: { duration: 0.25 } }}
                className="rounded-xl border border-gray-100 bg-white overflow-hidden hover:border-accent/40 hover:shadow-lg transition-all duration-300 cursor-pointer"
              >
                <div className="w-full aspect-[16/10] overflow-hidden">
                  <motion.img
                    src={solution.image}
                    alt={solution.title}
                    loading="lazy"
                    className="w-full h-full object-cover object-top"
                    width={440}
                    height={275}
                    whileHover={{ scale: 1.08 }}
                    transition={{ duration: 0.5 }}
                  />
                </div>
                <div className="p-5 md:p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <motion.div
                      whileHover={{ scale: 1.2, rotate: 8 }}
                      transition={{ type: "spring", stiffness: 400 }}
                      className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary/10 flex-shrink-0"
                    >
                      <i className={`${solutionIcons[index] || "ri-settings-line"} text-accent text-sm`}></i>
                    </motion.div>
                    <h3 className="text-base md:text-lg font-bold text-gray-800 group-hover:text-accent transition-colors">
                      {solution.title}
                    </h3>
                  </div>
                  <p className="text-sm text-gray-500 leading-relaxed">
                    {solution.description}
                  </p>
                </div>
              </motion.div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}